export const planDetails: Record<string, { name: string; monthlyPrice: number; yearlyPrice: number }> = Object.freeze({
  simb_free_plan: { name: "Free Plan", monthlyPrice: 0, yearlyPrice: 0 },
  simb_basic_plan: { name: "Basic Plan", monthlyPrice: 87, yearlyPrice: 47 },
  simb_small_plan: { name: "Basic Plan", monthlyPrice: 87, yearlyPrice: 47 }, // Maps to Basic Plan
  simb_standard_plan: { name: "Standard Plan", monthlyPrice: 127, yearlyPrice: 77 },
  simb_medium_plan: { name: "Standard Plan", monthlyPrice: 127, yearlyPrice: 77 }, // Maps to Standard Plan
  simb_pro_plan: { name: "Pro Plan", monthlyPrice: 197, yearlyPrice: 157 },
  simb_large_plan: { name: "Pro Plan", monthlyPrice: 197, yearlyPrice: 157 }, // Maps to Pro Plan
  simb_business_plan: { name: "Business Plan", monthlyPrice: 399, yearlyPrice: 299 },
  simb_unli_plan: { name: "Enterprise Plan", monthlyPrice: 497, yearlyPrice: 397 },
});
